import { useCreatorCashContext } from '../../../context/CreatorCashProvider';
import { howItWorksSteps } from '../../../utils/constants';
import FadeInSection from '../../FadeInComponent/FadeInComponent';
import FadeInComponent from '../../FadeInComponent/FadeInComponent';
import './HowItWorks.css';

export default function HowItWorks() {
    const { state } = useCreatorCashContext();
    const howItWorks = state?.howItWorks;

    return (
        <div className='how-it-works-container'>
            <div className='how-it-works-wrapper'>
                <FadeInComponent className="hiw-header">
                    <div className="hiw-header-title">{howItWorks?.title}</div>
                    <div className="hiw-header-sub-title">{howItWorks?.subTitle}</div>
                </FadeInComponent>
                <div className="hiw-content">
                    {
                        howItWorks?.steps?.map((step, index) => (
                            <FadeInSection className="hiw-step-container" key={index}>
                                <div>
                                    <span className="step">STEP {index + 1}</span>
                                </div>
                                <div className="hiw-step-title">{step?.title}</div>
                                <div className="hiw-step-content">
                                    <div className="hiw-step-sub-title">{step?.subTitle}</div>
                                    <div className="hiw-step-img" style={{ background: `url(${howItWorksSteps[index]}) no-repeat center / contain` }}></div>
                                </div>
                            </FadeInSection>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}